import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useSite } from "@/contexts/SiteContext";

export default function WhatsAppFloat() {
  const { settings } = useSite();
  const number = settings.whatsapp?.replace(/[^0-9]/g, "") || "918799757375";
  const url = `https://wa.me/${number}?text=${encodeURIComponent("Hi Hermanos Industries, I'm interested in wholesale garment supply. Please share more details.")}`;

  return (
    <motion.a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, duration: 0.5 }}
      whileHover={{ scale: 1.06 }}
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.35)] text-white"
      style={{ background: "#25D366" }}
      aria-label="WhatsApp Business"
    >
      <MessageCircle size={26} strokeWidth={1.8} />
      <span className="sr-only">Chat on WhatsApp</span>
    </motion.a>
  );
}
